export enum COMMON_ERROR_CODES {
    BAD_REQUEST = '400',
    UNAUTHORIZED = '401',
    FORBIDDEN = '403',
    NOT_FOUND = '404',
    INTERNAL_ERROR = '500',
    SERVICE_UNAVAILABLE = '503',
}

export type TErrorCode = number | string;

export const APP_SYNC_SUBSCRIPTIONS_EXCEPTIONS = 'UnauthorizedException';
export const NETWORK_ERROR = 'Network Error';
export const FAILED_FETCH = 'Failed to fetch';
export const SUBSCRIPTION_ERROR = 'SUBSCRIPTION_ERROR';

export const DEFAULT_ERROR_CODE: TErrorCode = 'api.unknown.exception';
export const INFORMATION_ERROR_CODE: TErrorCode = 'information.exception';
export const DEFAULT_AUTH_FORBIDDEN_ERROR = 'auth.access.forbidden';
export const DEFAULT_AUTH_UNAUTHORIZED= 'auth.unauthorized';
export const RESOURCE_NOT_FOUND_CODE = 'resource.not.found';
export const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try to refresh the page.';
export const INVALID_PARAMETERS_ERROR = 'bad.request.invalid.parameters';
export const SUBSCRIPTION_CONNECTION_LOST_ERROR ='Connection closed';
export const generateNetworkErrorMessage = (url: string): string => (
  `This application was not able to successfully connect to our system. 
  The issue could be due to firewalls blocking the following domain: ${url}. 
  Please reach out to Support for assistance at support@openexc.com.`
);
